"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayMetricCache = void 0;
const _1 = require(".");
const shared_1 = require("@snort/shared");
class RelayMetricCache extends shared_1.FeedCache {
    constructor() {
        super("RelayMetrics", _1.db.relayMetrics);
    }
    key(of) {
        return of.addr;
    }
    async preload() {
        await super.preload();
        // load everything
        await this.buffer([...this.onTable]);
    }
    takeSnapshot() {
        return [...this.cache.values()];
    }
}
exports.RelayMetricCache = RelayMetricCache;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVsYXktbWV0cmljLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NhY2hlL3JlbGF5LW1ldHJpYy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx3QkFBcUM7QUFDckMsMENBQTBDO0FBRTFDLE1BQWEsZ0JBQWlCLFNBQVEsa0JBQXVCO0lBQ3pEO1FBQ0ksS0FBSyxDQUFDLGNBQWMsRUFBRSxLQUFFLENBQUMsWUFBWSxDQUFDLENBQUM7SUFDM0MsQ0FBQztJQUVELEdBQUcsQ0FBQyxFQUFnQjtRQUNoQixPQUFPLEVBQUUsQ0FBQyxJQUFJLENBQUM7SUFDbkIsQ0FBQztJQUVRLEtBQUssQ0FBQyxPQUFPO1FBQ2xCLE1BQU0sS0FBSyxDQUFDLE9BQU8sRUFBRSxDQUFDO1FBQ3RCLGtCQUFrQjtRQUNsQixNQUFNLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0lBQ3pDLENBQUM7SUFFRCxZQUFZO1FBQ1IsT0FBTyxDQUFDLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDO0lBQ3BDLENBQUM7Q0FDSjtBQWxCRCw0Q0FrQkMifQ==